import { TextInput } from '@pandiafi/design-system'
import { Field, FieldProps } from 'formik'
import { t } from 'i18next'
import React from 'react'

import FormFieldWrapper from 'components/FormField'
import { BeneficiaryType } from 'views/TerminateContract/TerminateForm/initialValues'

interface BeneficiaryNameFieldProps {
  index: number
  required?: boolean
}

export const BeneficiaryNameField: React.FC<BeneficiaryNameFieldProps> = ({
  index,
  required,
}) => {
  return (
    <Field name={`beneficiaries.${index}.beneficiaryName`}>
      {({ field, meta }: FieldProps<BeneficiaryType['beneficiaryName']>) => (
        <FormFieldWrapper
          name={field.name}
          required={required}
          label={t('terminateContract:labels.beneficiaryName')}
          className="min-tablet:flex-1"
          meta={meta}
          labelBold
        >
          <TextInput {...field} />
        </FormFieldWrapper>
      )}
    </Field>
  )
}
